import type { LeaveSettingsResponse } from '@gokrew/models/leave-settings';
import api from './client';

/**
 * Fetches the leave settings data for the current user.
 */
export async function getLeaveSettings() {
  const { data } = await api.get<LeaveSettingsResponse>(
    '/employee/leave-settings'
  );
  return data;
}
